module.exports = __webpack_public_path__ + "a4fb3ca323367e52b7a63495e97b5816.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-20.svg
// module id = 566
// module chunks = 0